export const viewQueryKeys = {
  viewTPA: {
    all: () => ['view-tpa'] as const,
    details: (viewId: number) => ['view-tpa', 'details', viewId] as const,
    list: (roadmapId: number) => ['view-tpa', 'list', roadmapId] as const,
  },
  portfolioView: {
    detail: (loopId: number) => ['portfolioView', 'detail', loopId] as const,
  },
  scenarioView: {
    detail: (loopId: number) => ['scenarioView', 'detail', loopId] as const,
  },
  plannerLiveView: {
    detail: (loopId: number) => ['plannerLiveView', 'detail', loopId],
  },
  visualizations: {
    all: (loopId: number, viewId: number) => ['loop-view-visualizations', loopId, viewId] as const,
  },
  filter: {
    list: (viewId: number) => ['filters', viewId],
    detail: (viewId: number, fieldId: string) => ['filter', viewId, fieldId],
  },
  dateSource: {
    detail: (viewId: number) => ['view-date-source', viewId] as const,
  },
};
